export * from './fieldList';
import { FunctionTypes } from '../../../components/ContributorSection/helpers';
import React from 'react';

/** test ids for form and sections inside it */
export var BLOG_FORM_TEST_ID = "blog-form-test-id";
export var BLOG_FORM_PUB_INFO_TEST_ID = 'blog-form-pub-info-test-id';
export var BLOG_FORM_PUB_INFO_SECTION_NAME = 'pubonline';
export var BLOG_FORM_PUB_INFO_SECTION_TITLE = 'Publication info';
export var blogContributorOptions;
(function (blogContributorOptions) {
  blogContributorOptions["ArticleAuthor"] = "Article author";
  blogContributorOptions["WorkAuthor"] = "Work author";
  blogContributorOptions["Commenter"] = "Commenter";
  blogContributorOptions["Interviewer"] = "interviewer";
  blogContributorOptions["Interviewee"] = "interviewee";
  blogContributorOptions["Article"] = "article";
})(blogContributorOptions || (blogContributorOptions = {}));
export var RadioOptions;
(function (RadioOptions) {
  RadioOptions["ARTICLE"] = "article";
  RadioOptions["COMMENT"] = "comment";
  RadioOptions["INTERVIEW"] = "interview";
  RadioOptions["REVIEW"] = "review";
  RadioOptions["WEB_LOG"] = "web log";
  RadioOptions["AUDIO_BLOG"] = "audio blog";
  RadioOptions["VIDEO_BLOG"] = "video blog";
})(RadioOptions || (RadioOptions = {}));
var BLOG_ARTICLE_CONTRIBITION_OPTION = [{
  uuid: FunctionTypes.AUTHOR,
  value: FunctionTypes.AUTHOR,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, blogContributorOptions.ArticleAuthor)
}];
var BLOG_COMMENTOR_CONTRIBITION_OPTION = [{
  uuid: blogContributorOptions.Commenter,
  value: FunctionTypes.AUTHOR,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, blogContributorOptions.Commenter)
}];
var BLOG_REVIEW_CONTRIBITION_OPTION = [{
  uuid: FunctionTypes.REVIEWER,
  value: FunctionTypes.REVIEWER,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, FunctionTypes.REVIEWER)
}, {
  uuid: FunctionTypes.REVIEWED,
  value: FunctionTypes.REVIEWED,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, blogContributorOptions.WorkAuthor)
}];
var BLOG_INTERVIEW_CONTRIBITION_OPTION = [{
  uuid: blogContributorOptions.Interviewer,
  value: blogContributorOptions.Interviewer,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, blogContributorOptions.Interviewer)
}, {
  uuid: blogContributorOptions.Interviewee,
  value: blogContributorOptions.Interviewee,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, blogContributorOptions.Interviewee)
}];
var BLOG_DEFAULT_CONTRIBITION_OPTION = [{
  uuid: FunctionTypes.AUTHOR,
  value: FunctionTypes.AUTHOR,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, FunctionTypes.AUTHOR)
}, {
  uuid: FunctionTypes.EDITOR,
  value: FunctionTypes.EDITOR,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, FunctionTypes.EDITOR)
}, {
  uuid: FunctionTypes.COMPILER,
  value: FunctionTypes.COMPILER,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, FunctionTypes.COMPILER)
}, {
  uuid: FunctionTypes.TRANSLATOR,
  value: FunctionTypes.TRANSLATOR,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, FunctionTypes.TRANSLATOR)
}];
export var CITING_RADIO_OPTIONS = [{
  key: RadioOptions.ARTICLE,
  value: 'Article'
}, {
  key: RadioOptions.COMMENT,
  value: 'Comment'
}, {
  key: RadioOptions.REVIEW,
  value: 'Review'
}, {
  key: RadioOptions.INTERVIEW,
  value: 'Interview'
}];
export var BLOG_TYPE_OPTIONS = [{
  key: RadioOptions.WEB_LOG,
  value: 'Standard blog'
}, {
  key: RadioOptions.AUDIO_BLOG,
  value: 'Podcast (audio blog)'
}, {
  key: RadioOptions.VIDEO_BLOG,
  value: 'Vlog (video blog)'
}];
var BLOG_CONTRIBUTERES_MAP = {
  interview: BLOG_INTERVIEW_CONTRIBITION_OPTION,
  review: BLOG_REVIEW_CONTRIBITION_OPTION,
  comment: BLOG_COMMENTOR_CONTRIBITION_OPTION,
  article: BLOG_ARTICLE_CONTRIBITION_OPTION
};
export var getBlogContributorsOptions = function getBlogContributorsOptions(type) {
  if (type === 'interview') return BLOG_CONTRIBUTERES_MAP.interview;else if (type === 'review') return BLOG_CONTRIBUTERES_MAP.review;else if (type === 'comment') return BLOG_CONTRIBUTERES_MAP.comment;else if (type === 'article') return BLOG_CONTRIBUTERES_MAP.article;else return BLOG_DEFAULT_CONTRIBITION_OPTION;
};